export default {
  memberCommand: {
    "services": "Services",
    "diagnostics": "Developer diagnostics",
    "placeholder": "Find a page or action…",
    "club": "YOUR CLUB",
    "quick": "QUICK ACTIONS",
    "current": "Current",
    "navigate": "Navigate",
    "open": "Open",
    "close": "Close",
    "empty": "No matching pages or actions. Try another search.",
    "clear": "Clear search",
    "label": "Members navigation",
    "results": "{count} results available",
    "bookings": "My bookings",
    "account": "My account",
    "other": "Members Portal",
    "dashboard": "Your club at a glance",
    "book-facilities": "Golf, racquets, dining and more",
    "activities": "Discover ways to enjoy your club",
    "academy": "Camps, programmes and workshops",
    "events": "What’s on at your club",
    "reciprocal-clubs": "Explore your reciprocal network",
    "accommodations": "Find and book your next stay",
    "manage": "Manage your activities",
    "voting": "View club motions and vote",
    "dashboardKeywords": "home overview",
    "book-facilitiesKeywords": "reservations sports restaurant courts",
    "activitiesKeywords": "clubs hobbies",
    "academyKeywords": "learning courses lessons",
    "eventsKeywords": "calendar tickets",
    "reciprocal-clubsKeywords": "partners travel access",
    "accommodationsKeywords": "hotel rooms stays",
    "manageKeywords": "administration activities",
    "votingKeywords": "motions ballots"
},
  member_all_handicaps: "All handicaps",
  member_handicap_or_better: "Handicap {value} or better",
  member_handicap_or_worse: "Handicap {value} or worse",

  member_leave: "Leave",
  member_unable_to_leave_this_open_group_right_now: "Unable to leave this open group right now.",
  member_leave_group_confirm: "Leave this open group?",
  member_hosts_manage_booking: "Manage your booking from Upcoming bookings.",
  member_loading_open_groups: "Loading open groups…",
  member_open_groups: "Open groups",
  member_open_group_help: "Invite other members to fill the places you choose. Your booking stays private unless you select Open group.",
  member_level_not_provided: "Level not provided",
  member_level_metric: "Level",
  member_handicap_metric: "Handicap",
  member_all_levels: "All levels",
  member_level_preferences: "Preferred level range",
  member_level_preferences_help: "Optional · profile scale 1–5. Leave both blank for all levels. This is a preference.",
  member_minimum_level: "Minimum level",
  member_maximum_level: "Maximum level",
  member_open_groups_load_failed: "Unable to load open groups.",
  member_open_group_details_failed: "Unable to load group details.",

  member_events_retry: "Try again",
  "member_events_heading": "Events",
  "member_event_count_one": "{count} event",
  "member_event_count_other": "{count} events",
  "at_risk": "At risk",
  "super_engaged": "Super engaged",
  "proactive_exposure_recovery_opportunities": "Proactive exposure & recovery opportunities",
  "outstanding": "Outstanding",
  "cancellations": "Cancellations",
  "disengagement": "Disengagement",
  "membership_spend_ytd": "Membership spend · YTD",
  "total_members": "Total members",
  "new_members": "New members",
  "this_month": "This month",
  "amount_due": "Amount due",
  "member_accounts": "Member accounts",
  "find_a_member": "Find a member",
  "search_members": "Search members",
  "hidden_patterns_across_your_club": "Hidden patterns across your club",
  "no_current_intelligence_items": "No current intelligence items.",
  "no_upcoming_birthdays": "No upcoming birthdays",
  "nothing_in_the_current_period": "Nothing in the current period",
  "club_conditions_and_forecast": "Club conditions and forecast",
  "view_current_conditions": "View current conditions",
  "open_the_live_club_forecast": "Open the live club forecast",
  "unable_to_load_this_dashboard_data_right_now": "Unable to load this dashboard data right now.",
  "loading_exposure_detail": "Loading exposure detail…",
  "outstanding_balances": "Outstanding balances",
  "cancellations_refunds": "Cancellations & refunds",
  "disengagement_exposure": "Disengagement exposure",
  "total_exposure": "Total exposure",
  "record": "Record",
  "no_records_in_this_category": "No records in this category.",
  "loading_metrics": "Loading metrics…",
  "unable_to_load_leadership_metrics": "Unable to load leadership metrics.",
  "executive_snapshot_year_to_date": "Executive snapshot · Year to date",
  "membership_spend": "Membership spend",
  "net_movement_this_month": "Net movement this month",
  "member_account_exposure": "Member-account exposure",
  "membership_health": "Membership health",
  "revenue_exposure_composition": "Revenue exposure composition",
  "needs_attention": "Needs attention",
  "outstanding_member_account_balances_require_review": "Outstanding member-account balances require review.",
  "loading_intelligence": "Loading intelligence…",
  "dashboard_details": "Dashboard details",
  "favourites": "Favourites",
  "new_chat": "New chat",
  "collapse_panel": "Collapse Panel",
  "show_history": "Show History",
  "loading_conversation": "Loading conversation…",
  "conversation_could_not_be_restored": "Conversation could not be restored",
  "retry_loading": "Retry loading",
  "how_can_i_help_you_manage_the_club_today": "How can I help you manage the club today?",
  "external_sources": "External sources",
  "sources": "Sources",
  "prepare_again": "Prepare again",
  "sms_option": "SMS Option",
  "no_message_preview_available": "No message preview available.",
  "sent": "Sent",
  "member_option": "Member option",
  "select": "Select",
  "review_proposed_action": "Review proposed action",
  "review_draft": "Review Draft",
  "review_action": "Review Action",
  "staff_member": "Staff member",
  "email_draft": "Email draft",
  "select_one_of_your_mailboxes": "Select one of your mailboxes",
  "connect_your_mailbox_to_prepare_mailbox_backed_drafts_later": "Connect your mailbox to prepare mailbox-backed drafts later",
  "recipients": "Recipients",
  "no_recipients_selected_editable_unsent_draft": "No recipients selected · editable, unsent draft",
  "recipient_contact_details_need_attention_this_draft_remains_saved_and_unsent": "Recipient contact details need attention. This draft remains saved and unsent.",
  "recipients_individual_emails": "recipients · individual emails",
  "missing_email": "missing email",
  "subject": "Subject",
  "email_subject": "Email subject",
  "email_cc": "Email CC",
  "email_bcc": "Email BCC",
  "sender_mailbox": "Sender mailbox",
  "server_selected_mailbox": "Server-selected mailbox",
  "email_body": "Email body",
  "preview_personalised_email": "Preview personalised email",
  "first_name_is_personalised_for_each_recipient": "First name is personalised for each recipient.",
  "preview_recipient": "Preview recipient",
  "previewing_as": "Previewing as",
  "recipient": "recipient",
  "your_saved_signature": "Your saved signature",
  "connect_mailbox": "Connect mailbox",
  "discard": "Discard",
  "reload_draft": "Reload Draft",
  "action_failed": "Action Failed",
  "an_unknown_error_occurred": "An unknown error occurred.",
  "golf_outing_created": "Golf Outing Created!",
  "view_in_events": "View in Events",
  "view_tee_sheet": "View Tee Sheet",
  "action_successful": "Action Successful",
  "stopping": "Stopping…",
  "preparing_your_answer": "Preparing your answer.",
  "confirm_send": "Confirm Send",
  "target": "Target:",
  "confirming": "Confirming…",
  "privana_assist_is_working": "Privana Assist is working…",
  "answer_now_becomes_available_after_verified_work_completes": "Answer now becomes available after verified work completes.",
  "answer_now": "Answer now",
  "unable_to_continue": "Unable to continue",
  "completed_evidence_and_outputs_were_retained": "Completed evidence and outputs were retained.",
  "completed_verified_work_was_retained_you_can_retry_when_the_reported_constraint_is_resolved": "Completed verified work was retained. You can retry when the reported constraint is resolved.",
  "jump_to_latest": "Jump to latest",
  "retry_loading_this_conversation_before_sending": "Retry loading this conversation before sending.",
  "finish_cancel_or_answer_the_current_request_before_starting_another": "Finish, cancel, or answer the current request before starting another.",
  "ask_privana_e_g_add_a_new_member_named_john_smith": "Ask Privana... (e.g., 'add a new member named John Smith')",
  "send_message": "Send message",
  "conversation_loading_failed_retry_is_required_before_you_can_send": "Conversation loading failed. Retry is required before you can send.",
  "explore": "Explore",
  "shift_enter_for_newline": "Shift+Enter for newline",
  "edit_sms_option": "Edit SMS (Option",
  "upcomingOne": "{count} upcoming birthday",
  "upcomingMany": "{count} upcoming birthdays",
  "inDaysOne": "In {count} day",
  "inDaysMany": "In {count} days",
  "atRiskOne": "{count} member is currently classified as at risk.",
  "atRiskMany": "{count} members are currently classified as at risk.",
  "confidence": "Confidence",
  "confidenceHigh": "High",
  "confidenceMedium": "Medium",
  "confidenceLow": "Low",
  "confidenceCurrent": "Current",
  "nextStep": "Next step: {action}",
  "highLow": "H: {high}° L: {low}°",
  "precipitation": "Chance of precipitation",
  "keypadKey": "Dial {key}",
  "starKey": "star",
  "hashKey": "hash",
  "deleteDigit": "Delete last digit",
  "favouriteChat": "Favourite conversation",
  "unfavouriteChat": "Remove conversation from favourites",
  "deleteChat": "Delete conversation",
  "emptyHistory": "No conversations yet.",
  "emptyFavourites": "No favourite conversations yet.",
  "patterns": {
    "department_exposure_concentration": {
      "headline": "Revenue risk is concentrated in {department}",
      "evidence": "{percent}% of current exposure is linked to {department}.",
      "implication": "A swing in this department could hit cash quickly. Assign an owner to review top receivables and cancellation drivers in {department} this week.",
      "actionLabel": "Review {department} dependency"
    },
    "outstanding_balance_department_concentration": {
      "headline": "Most outstanding balances are tied to {department}",
      "evidence": "{percent}% of open balances are from {department}.",
      "implication": "Collections impact is likely highest in {department}; prioritizing this queue should accelerate cash recovery.",
      "actionLabel": "Prioritize {department} collections"
    },
    "cancellation_day_of_week_spike": {
      "headline": "Cancellations are clustering on {day}s",
      "evidence": "{percent}% of the last 90 days’ cancellations happened on {day} (about {ratio}x other weekdays).",
      "implication": "This usually points to a day-specific service or scheduling friction. Review {day} staffing, booking windows, and cancellation reasons.",
      "actionLabel": "Audit {day} booking flow"
    },
    "disengagement_department_overlap": {
      "headline": "At-risk members are over-indexed in {department}",
      "evidence": "{percent}% of low-engagement risk members map to {department} activity patterns.",
      "implication": "A targeted re-engagement campaign in {department} could reduce future revenue leakage.",
      "actionLabel": "Launch {department} re-engagement"
    },
    "revenue_vs_activity_divergence": {
      "headline": "Revenue is rising faster than member activity",
      "evidence": "Revenue is up {revenueChange}% over 30 days while transaction activity is {activityChange}%.",
      "implication": "Revenue growth may be coming from price/mix instead of broader participation. Check which departments and member cohorts are carrying the lift.",
      "actionLabel": "Validate growth quality by segment"
    },
    "receivables_cluster_by_department": {
      "headline": "Older receivables are concentrated in {department}",
      "evidence": "{percent}% of 60+ day balances are in {department}.",
      "implication": "Collections drag appears concentrated. A focused aging strategy in {department} should improve recoveries.",
      "actionLabel": "Focus 60+ day outreach in {department}"
    },
    "rising_risk_falling_usage": {
      "headline": "Member risk is increasing while exposure stays narrowly concentrated",
      "evidence": "At-risk members rose by {delta} while {department} still represents {percent}% of exposure.",
      "implication": "If member risk keeps rising, this concentration can escalate fast. Prioritize outreach for high-balance members in the exposed department.",
      "actionLabel": "Contact high-balance at-risk members first"
    }
  },
  "departments": {
    "membership": "Membership",
    "golf": "Golf",
    "racquet": "Racquet",
    "spa": "Spa",
    "rooms": "Rooms",
    "events": "Events",
    "fitness": "Fitness",
    "other": "Other"
  },
  "this_insight_could_not_be_displayed": "This insight could not be displayed.",
  "no_chart_data_is_available": "No chart data is available.",
  "series": "Series:",
  "categories": ". Categories:",
  "data_is_unavailable": "data is unavailable",
  "comparison_data_is_available_for": "Comparison data is available for",
  "of_the": "of the",
  "displayed_periods_gaps_are_unavailable": "displayed periods; gaps are unavailable.",
  "partial_data_available_from": "Partial data: available from",
  "categories_were_limited_to_the_most_significant_results": "Categories were limited to the most significant results.",
  "view_data": "View data",
  "download_csv": "Download CSV",
  "open_in_module": "Open in module",
  "exact_data_used_for": "Exact data used for",
  "current_period_is_incomplete_its_value_is_provisional": "* Current period is incomplete; its value is provisional.",
  "about_this_chart": "About this chart",
  "complete_through": "Complete through",
  "generated": ") · generated",
  "latest_observed_record": "Latest observed record:",
  "compared_with": "Compared with",
  "the_current_period_is_incomplete": "The current period is incomplete.",
  "club_inventory": "Club inventory",
  "show": "Show",
  "more": "more",
  "fytd": "FYTD",
  "joined": "Joined",
  "renewal": "Renewal",
  "account": "Account",
  "contact": "Contact",
  "recent_activity": "Recent activity",
  "no_recent_activity_recorded": "No recent activity recorded.",
  "showing": "Showing",
  "of_at_least": "of at least",
  "rows": "rows.",
  "coverage": "Coverage",
  "comparison": "Comparison",
  "revision": "· revision",
  "key_findings": "Key Findings",
  "supporting_chart_is_unavailable_or_no_longer_accessible": "Supporting chart is unavailable or no longer accessible.",
  "risks_and_exceptions": "Risks and exceptions",
  "recommendations": "Recommendations",
  "intended_outcome": "Intended outcome:",
  "next_actions": "Next actions",
  "coverage_limitations": "Coverage & Limitations",
  "about_this": "About this",
  "data_used": "Data used",
  "why": "Why?",
  "report_revision": "Report Revision",
  "calculation_date": "Calculation date",
  "trading_picture": "Trading picture",
  "vs": "vs",
  "revenue_by_department": "Revenue by department",
  "variance": "· variance",
  "revenue_trend": "Revenue trend",
  "collections_by_method": "Collections by method",
  "privana_observations": "Privana observations",
  "live_operational_weather": "Live operational weather",
  "live_club_forecast_updated": "Live club forecast · Updated",
  "this_file_is_no_longer_stored_generated_files_are_retained_for_7_days": "This file is no longer stored. Generated files are retained for 7 days.",
  "available_until": "Available until",
  "loading_preview": "Loading preview…",
  "view_member": "View member",
  "create_golf_outing": "Create Golf Outing",
  "event_title": "Event Title",
  "description": "Description",
  "max_capacity": "Max Capacity",
  "start_time": "Start Time",
  "end_time": "End Time",
  "location": "Location",
  "weather_forecast": "Weather forecast",
  "golf_scope": "Golf scope",
  "booked_players": "Booked players",
  "tee_utilisation": "Tee utilisation",
  "occupied_slots": "Occupied slots",
  "available_slots": "Available slots",
  "forecast_date": "Forecast date",
  "operational_risk": "Operational risk",
  "current_snapshot": "Current snapshot",
  "previous_year": "Previous year",
  "for_the_displayed_periods": " for the displayed periods",
  "creating": "Creating...",
  "untitled": "Untitled",
  "report": "Report",
  "noMatches": "No matching results",
  "unavailableData": "This information is unavailable right now.",
  "assistUnavailable": "Assist temporarily unavailable. Please retry this message.",
  "draftConflict": "This draft could not be updated. Reload it before trying again.",
  "queued": "Request accepted.",
  "running": "Privana Assist is working…",
  "finalising": "Finishing your answer…",
  "cancelling": "Stopping…",
  "paused": "Paused",
  "failed": "Unable to continue",
  "openFile": "Open {name}",
  "downloadFile": "Download {name}",
  "termUnavailable": "Membership term information could not be checked right now.",
  "noRenewal": "No explicit renewal date recorded.",
  "noTerm": "No current membership term recorded.",
  "financeUnavailable": "Financial information could not be checked right now.",
  "accountAvailable": "Account position available.",
  "viewProfile": "View member profile",
  "previewFailed": "Preview unavailable.",
  "downloadFailed": "Download unavailable.",
  "openFailed": "Open unavailable.",
  "restricted": "You do not have permission to view this information.",
  "references": {
    "outstanding": "Outstanding balance",
    "cancelled": "Cancelled booking or refund",
    "engagement": "Low engagement trend"
  },
  "available": "Available",
  "partial": "Partial",
  "unavailable": "Unavailable",
  "high": "High",
  "medium": "Medium",
  "low": "Low",
  "unknown": "Unknown",
  "result": "Result",
  "weatherLow": "Good for outdoor operations",
  "weatherElevated": "Some disruption risk",
  "weatherHigh": "High disruption risk",
  "gusts": "gusts",
  "low_source_coverage": "some sources have limited coverage",
  "insufficient_points": "only limited historical data is available",
  "partially_available": "not all requested domains returned usable evidence",
  "no_comparison_period": "previous-period comparison is unavailable",
  "provisional_period": "the current period is not complete",
  "source_coverage": "source coverage is limited",
  "coverageLimited": "{names} data was not available for this period, so the report’s operational assessment is limited.",
  "coverageHelp": "This report includes the available evidence and notes any limitations below.",
  "revenueRecords": "Revenue records",
  "memberRecords": "Membership records",
  "receivableRecords": "Receivables records",
  "eventRecords": "Event records",
  "elementRecords": "Element records",
  "managementRecords": "Available management records",
  "and": " and ",
  "tableLabel": "{title} table",
  "becauseRecordsBegin": " because records begin on {date}",
  "completed": "Complete",
  "unspecified": "Unspecified",
  "none": "None",
  "confidenceBadge": "{value} confidence",
  "analyticalDescription": "Showing {series} by {dimension}.",
  "analyticalView": "Analytical view.",
  "governedResult": "Governed analytical result",
  "supportedEvidence": "Supported by the available evidence.",
  "collapse": "Collapse",
  "briefing": "Briefing",
  "working": "Working…",
  "originalReport": "Original report",
  "revisionReport": "Revision from earlier report",
  "extensionReady": "Extension Ready",
  "transferringTarget": "Transferring to {target}…",
  "consultControls": "Consultation call controls",
  "consultDialpad": "Consultation dialpad",
  "closeDialpad": "Close Dialpad",
  "sendDtmf": "Send DTMF {digit}",
  "unmute": "Unmute",
  "hangUp": "Hang Up",
  "inProgress": "In progress",
  "consultation_active": "Consultation active",
  "financeStatuses": {
    "draft": "Draft",
    "submitted": "Submitted",
    "board_approved": "Board approved",
    "approved": "Approved",
    "locked": "Locked",
    "favourable": "Favourable",
    "adverse": "Adverse",
    "on_budget": "On budget",
    "consistent": "Consistent",
    "mismatch": "Mismatch",
    "reconciled": "Reconciled",
    "explained_difference": "Explained difference",
    "unexplained_difference": "Unexplained difference",
    "insufficient_evidence": "Insufficient evidence"
  },
  "destination_prepared": "Destination prepared",
  "destination_ringing": "Destination ringing",
  "consultation_failed": "Consultation failed",
  "consultation_cancelling": "Cancelling consultation",
  "consultation_cancelled": "Consultation cancelled",
  "clubFallback": "Club",
  "atAGlance": "{club} at a glance",
  "cc": "CC",
  "bcc": "BCC",
  "proceed": "How would you like to proceed?",
  "selectMemberFailed": "Unable to select that member. Please try again.",
  "reviewSms": "Please review and confirm before I send this SMS.",
  "confirmationCancelled": "Confirmation cancelled. No message was sent.",
  "verifyAction": "Assist temporarily unavailable. Please verify the action status before retrying.",
  "discardedEdit": "Discarded drafts cannot be edited.",
  "saveDraftFailed": "Could not save",
  "discardDraftFailed": "Could not discard",
  "forwardedMessage": "Forwarded message",
  "smsFailed": "SMS failed to send.",
  "smsSimulation": "SMS simulation only — no real text message was sent.",
  "smsSimulationLine": "Simulation only ⚠️ No SMS was sent to the member.",
  "smsNotSent": "SMS not sent ⚠️",
  "smsSuccess": "Message sent successfully",
  "smsSent": "SMS sent ✅",
  "golfOutingPlaceholder": "Golf Outing",
  "selectCourse": "Select a course...",
  "courseVenue": "Course / venue name",
  "allGolfCourses": "All Golf courses",
  "member_back_to_accommodations": "Back to accommodations",
  "member_your_booking": "your booking",
  "member_confirm_occupancy_settlement_method_and_submit_your_booking_request": "Confirm occupancy, settlement method, and submit your booking request.",
  "member_booking_request_confirmed": "Booking request confirmed",
  "member_your_accommodation_request_is_now_pending_confirmation_from_the_club_team": "Your accommodation request is now pending confirmation from the club team.",
  "member_reservation_reference": "Reservation reference:",
  "member_photos_coming_soon": "Photos coming soon",
  "member_previous_photo": "Previous photo",
  "member_next_photo": "Next photo",
  "member_room_plan": "Room plan",
  "member_adults": "adults ·",
  "member_children": "children",
  "member_anything_we_should_prepare": "Anything we should prepare?",
  "member_special_requests_optional": "Special requests (optional)",
  "member_late_arrival_adjoining_rooms_dietary_preferences_or_anything_else": "Late arrival, adjoining rooms, dietary preferences, or anything else.",
  "member_review_confirm": "Review & Confirm",
  "member_nights": "Nights",
  "member_rooms_guests": "Rooms · Guests",
  "member_rooms": "rooms ·",
  "member_nightly_rate_per_room": "Nightly rate (per room)",
  "member_add_to_member_account": "Add to member account",
  "member_pay_by_card_online": "Pay by card online",
  "member_pay_on_arrival": "Pay on arrival",
  "member_this_room_type_does_not_yet_have_a_configured_rate_please_contact_the_club": "This room type does not yet have a configured rate. Please contact the club.",
  "member_visual_coming_soon": "Visual coming soon",
  "member_rooms_available": "rooms available",
  "member__night": "/ night",
  "member_stay_in": "Stay in",
  "member_style": "style",
  "member_choose_your_dates_and_room_setup_to_see_currently_available_suites": "Choose your dates and room setup to see currently available suites.",
  "member_check_in_check_out": "Check-in / Check-out",
  "member_guests_rooms": "Guests / Rooms",
  "member_add_rooms_as_needed": "Add rooms as needed",
  "member_decrease_rooms": "Decrease rooms",
  "member_increase_rooms": "Increase rooms",
  "member_adults_2": "Adults",
  "member_children_2": "Children",
  "member_check_availability": "Check availability",
  "member_step_2": "Step 2",
  "member_available_room_types": "Available room types",
  "member_loading_suites_and_rooms": "Loading suites and rooms…",
  "member_no_rooms_are_available_to_request_right_now": "No rooms are available to request right now.",
  "member_accommodation_room_details": "Accommodation room details",
  "member_close_room_details": "Close room details",
  "member_total_estimate": "Total estimate",
  "member_continue_to_booking": "Continue to booking",
  "member_discover_club_programming": "Discover club programming",
  "member_loading_activities": "Loading activities…",
  "member_no_activities_are_available_right_now": "No activities are available right now.",
  "member_view_sessions": "View sessions",
  "member_book_or_manage_your_reservation": "Book or manage your reservation.",
  "member_back_to_activities": "Back to activities",
  "member_loading_sessions": "Loading sessions…",
  "member_no_sessions_are_scheduled_yet": "No sessions are scheduled yet.",
  "member_dismiss_notification": "Dismiss notification",
  "member_players": "players ·",
  "member_can_cancel": "Can cancel",
  "member_total_cost": "Total cost",
  "member_no_players_listed": "No players listed",
  "member_no_add_ons": "No add-ons",
  "member_cancellation_policy_status": "Cancellation policy status",
  "member_you_may_cancel_this_booking_online_under_the_club_s_cancellation_policy": "You may cancel this booking online under the club’s cancellation policy.",
  "member_cutoff": "Cutoff:",
  "member_hours_before_tee_time": "hours before tee time",
  "member_cancel_booking": "Cancel Booking",
  "member_you_may_cancel_this_racquet_booking_through_member_portal_cancellation": "You may cancel this Racquet booking through member portal cancellation.",
  "member_you_may_cancel_this_spa_booking_through_member_portal_cancellation": "You may cancel this Spa booking through member portal cancellation.",
  "member_fitness_booking": "Fitness Booking",
  "member_you_may_cancel_this_fitness_booking_through_member_portal_cancellation": "You may cancel this Fitness booking through member portal cancellation.",
  "member_full_stay_cost": "Full stay cost",
  "member_you_may_cancel_this_hotel_rooms_booking_through_member_portal_cancellation": "You may cancel this Hotel / Rooms booking through member portal cancellation.",
  "member_need_to_adjust_this_booking_please_contact_the_club": "Need to adjust this booking? Please contact the club.",
  "member_club_overview": "Club overview",
  "member_resolving_member_profile": "Resolving member profile",
  "member_welcome_to_your_private_sanctuary": "Welcome to your private sanctuary",
  "member_let_s_play": "Let’s Play!",
  "member_upcoming_bookings": "Upcoming Bookings",
  "member_your_next_experiences_at_the_club": "Your next experiences at the club",
  "member_check_back_here_soon_for_more_exciting_club_news": "Check back here soon for more exciting club news!",
  "member_loading_club_news": "Loading club news",
  "member_member_updates": "Member updates",
  "member_preparing_pdf_viewer": "Preparing PDF viewer…",
  "member_mark_as_read": "Mark as read",
  "member_member_bookings": "Member bookings",
  "member_all_upcoming_experiences": "All Upcoming Experiences",
  "member_upcoming": "upcoming",
  "member_upcoming_bookings_carousel": "Upcoming Bookings carousel",
  "member_select_a_booking_to_view_details": "Select a booking to view details",
  "member_choose_a_booking_from_the_list_to_see_policy_information_players_add_ons_payment_details_and_available_actions": "Choose a booking from the list to see policy information, players, add-ons, payment details, and available actions.",
  "member_close_cancellation_confirmation": "Close cancellation confirmation",
  "member_cancel_this_tee_time": "Cancel this tee time?",
  "member_this_will_cancel_your_tee_time_and_update_your_member_account_this_cannot_be_undone_online": "This will cancel your tee time and update your member account. This cannot be undone online.",
  "member_keep_booking": "Keep Booking",
  "member_cancel_tee_time": "Cancel Tee Time",
  "member_cancel_this_racquet_booking": "Cancel this Racquet booking?",
  "member_this_will_cancel_your_booking_and_apply_the_club_cancellation_policy": "This will cancel your booking and apply the club cancellation policy.",
  "member_cancel_this_spa_booking": "Cancel this Spa booking?",
  "member_cancel_this_fitness_booking": "Cancel this Fitness booking?",
  "member_cancel_this_hotel_rooms_booking": "Cancel this Hotel / Rooms booking?",
  "member_this_will_cancel_your_stay_and_apply_the_club_cancellation_policy": "This will cancel your stay and apply the club cancellation policy.",
  "member_explore_exclusive_events": "Explore exclusive events...",
  "member_search_titles_venues_or_occasion_type": "Search titles, venues, or occasion type",
  "member_event_timeframe": "Event timeframe",
  "member_my_calendar": "My calendar",
  "member_confirmed_attendance": "Confirmed attendance",
  "member_accessibility": "Accessibility",
  "member_remove_guest": "Remove guest",
  "member_attendance_notes": "Attendance notes",
  "member_dietary_needs_accessibility_notes_or_concierge_requests": "Dietary needs, accessibility notes, or concierge requests",
  "member_book_facilities": "Book Facilities",
  "member_choose_your_next_activity": "Choose your next activity",
  "member_facilities_could_not_be_refreshed": "Facilities could not be refreshed.",
  "member_loading_facilities": "Loading facilities",
  "member_facilities_will_appear_here_when_your_club_enables_them": "Facilities will appear here when your club enables them.",
  "member_available_times": "AVAILABLE TIMES",
  "member_loading_availability": "Loading availability…",
  "member_no_available_times_for_this_day": "No available times for this day.",
  "member_loading_schedule": "Loading schedule…",
  "member_no_upcoming_fitness_classes_with_availability": "No upcoming fitness classes with availability.",
  "member_sessions": "sessions",
  "member_view_open_groups": "View Open Groups",
  "member_view_rates": "View rates",
  "member_no_available_tee_times_for_this_day": "No available tee times for this day.",
  "member_up_to": "Up to",
  "member_players_2": "players",
  "member_book_now": "Book Now",
  "member_rates_are_not_available_yet_please_contact_the_pro_shop": "Rates are not available yet. Please contact the pro shop.",
  "member_back_to_tee_times": "Back to tee times",
  "member_course_rates": "Course rates",
  "member_loading_course": "Loading course…",
  "member_select_rate_type": "Select rate type",
  "member_member_rates": "Member rates",
  "member_guest_rates": "Guest rates",
  "member_pricing": "pricing",
  "member__hole": "-hole",
  "member_fetching_available_courses_for_your_club": "Fetching available courses for your club.",
  "member_choose_your_course": "Choose your course",
  "member_select_a_course_to_view_available_tee_times": "Select a course to view available tee times.",
  "member_no_active_courses_are_available_for_booking_yet": "No active courses are available for booking yet.",
  "member_court": "court",
  "member_private_booking": "Private booking",
  "member_open_match": "Open match",
  "member_match_type": "Match type",
  "member_competitive": "Competitive",
  "member_who_can_join": "Who can join",
  "member_host_approval": "Host Approval",
  "member_direct_join": "Direct Join",
  "member_optional_note": "Optional note",
  "member_anything_players_should_know": "Anything players should know?",
  "member_add_to_your_booking": "Add to your booking",
  "member_view_other_times": "View other times",
  "member_close_player_sheet": "Close player sheet",
  "member_search_by_name": "Search by name",
  "member_searching_members": "Searching members",
  "member_sport_not_supported": "Sport not supported",
  "member_we_couldn_t_recognize_this_sport_please_return_to_facilities": "We couldn't recognize this sport. Please return to facilities.",
  "member_back_to_courts": "Back to courts",
  "member_confirm_your_court": "Confirm your court",
  "member_book_a_court": "Book a court",
  "member_create_open_match": "Create open match",
  "member_select_open_match_type": "Select open match type",
  "member_select_join_policy": "Select join policy",
  "member_open_match_note": "Open match note",
  "member_optional_details_for_players_joining": "Optional details for players joining",
  "member_mobile_for_updates": "Mobile for updates",
  "member_email_for_confirmation": "Email for confirmation",
  "member__add_player": "+ Add player",
  "member_maximum_players_reached_for_this_court": "Maximum players reached for this court.",
  "member_enhance_your_visit": "Enhance your visit",
  "member_no_add_ons_available_for_this_sport": "No add-ons available for this sport.",
  "member_racquet_booking": "Racquet booking",
  "member_estimated_total": "Estimated total",
  "member_calculated_from_live_pricing_policy": "Calculated from live pricing policy",
  "member_default_session": "Default session:",
  "member_member_rate_on_file": "Member rate on file",
  "member_guest_rate_on_file": "Guest rate on file",
  "member_left": "left",
  "member_skill": "Skill",
  "member_vacant_spot": "Vacant spot",
  "member_no_pending_join_requests_right_now": "No pending join requests right now.",
  "member_pending_invites": "Pending invites",
  "member_back_to_racquet_availability": "Back to racquet availability",
  "member_loading_match_details": "Loading match details…",
  "member_back_to_facilities": "Back to facilities",
  "member_no_courts_available_for": "No courts available for",
  "member_select_court_date": "Select court date",
  "member_open_matches": "Open matches",
  "member_loading_open_matches": "Loading open matches…",
  "member_no_open_matches_available_for_this_date": "No open matches available for this date.",
  "member_choose_a_time": "Choose a time",
  "member_no_available_start_times_for_this_day": "No available start times for this day.",
  "member_available_start_times": "Available start times",
  "member_choose_a_court": "Choose a court",
  "member_no_courts_are_available_for_this_time": "No courts are available for this time.",
  "member_no_slots_available_for_this_day": "No slots available for this day.",
  "member_open_matches_to_join": "Open matches to join",
  "member_spots_left": "spots left",
  "member_your_match": "Your match",
  "member_view_requests": "View requests",
  "member_payment_required": "Payment required",
  "member_due": "due",
  "member_add_to_account": "Add to account",
  "member_pay_online": "Pay online",
  "member_you_are_in_this_match": "You are in this match",
  "member_host_controls": "Host controls",
  "member_manage_open_match": "Manage open match",
  "member_manage_open_match_requests": "Manage open match requests",
  "member_pay_online_for_open_match": "Pay online for open match",
  "member_payment_summary": "Payment summary",
  "member_match_time_date": "Match time/date",
  "member_cardholder_name": "Cardholder name",
  "member_card_number": "Card number",
  "member_expiry": "Expiry",
  "member_mm_yy": "MM/YY",
  "member_billing_postcode_zip": "Billing postcode / ZIP",
  "member_online_card_payments_are_not_enabled_yet": "Online card payments are not enabled yet.",
  "member_confirm_payment": "Confirm payment",
  "member_members_portal": "MEMBERS PORTAL",
  "member_browse_partner_clubs_and_request_a_guest_pass_to_visit": "Browse partner clubs and request a guest pass to visit.",
  "member_search_by_club_or_location": "Search by club or location",
  "member_loading_reciprocal_clubs": "Loading reciprocal clubs…",
  "member_no_partner_clubs_available_yet": "No partner clubs available yet.",
  "member_amenities_coming_soon": "Amenities coming soon",
  "member_visit_website": "Visit website",
  "member_reciprocal_club": "Reciprocal Club",
  "member_amenities_coming_soon_2": "Amenities coming soon.",
  "member_visit_date": "Visit date",
  "member_note_message_optional": "Note/message (optional)",
  "member_let_us_know_anything_helpful_for_your_visit": "Let us know anything helpful for your visit.",
  "member_request_sent": "Request sent!",
  "member_your_guest_pass_request_has_been_submitted_we_ll_notify_you_once_it_s_approved": "Your guest pass request has been submitted. We'll notify you once it's approved.",
  "member_request_reference": "Request reference:",
  "member_back_to_reciprocal_clubs": "Back to reciprocal clubs",
  "member_back_to_services": "Back to services",
  "member_choose_a_service": "Choose a service",
  "member_search_services": "Search services",
  "member_loading_services": "Loading services…",
  "member_no_spa_services_available": "No spa services available.",
  "member_holes": "holes",
  "member_confirm_your_time": "Confirm your time",
  "member_please_select_holes_to_continue": "Please select holes to continue.",
  "member_open_group": "OPEN GROUP",
  "member_open_group_toggle": "Open group toggle",
  "member_open_group_2": "Open Group",
  "member_open_groups_not_available_for_this_player_mix": "Open groups not available for this player mix.",
  "member_looking_for": "Looking for",
  "member_open_group_size": "Open group size",
  "member_player": "player",
  "member_min_handicap_optional": "Min handicap (optional)",
  "member_e_g_10_0": "e.g. 10.0",
  "member_max_handicap_optional": "Max handicap (optional)",
  "member_e_g_24_0": "e.g. 24.0",
  "member_note_for_guests_optional": "Note for guests (optional)",
  "member_share_expectations_or_preferences": "Share expectations or preferences",
  "member_spots_available": "Spots available:",
  "member_enhance_your_round": "Enhance your round",
  "member_open_groups_to_join": "Open groups to join",
  "member_play_with_others": "Play with others",
  "member_no_open_groups_for_this_date_yet": "No open groups for this date yet.",
  "member__spots_available": "· Spots available:",
  "member_golf_booking": "Golf booking",
  "member_open_group_2_3": "Open group",
  "member_retry_price": "Retry price",
  "member_includes_add_ons_selected": "Includes add-ons selected",
  "member_booking_checkout": "Booking checkout",
  "member_go_to_dashboard": "Go to dashboard",
  "member_member_profile": "Member profile",
  "member_mobile_bottom_navigation": "Mobile bottom navigation",
  "member_clearing": "Clearing",
  "member_loading_notifications": "Loading notifications…",
  "member_no_notifications_yet": "No notifications yet",
  "member_pending_confirmation": "Pending confirmation",
  "member_select_a_room_type": "Select a room type",
  "member_confirm_booking": "Confirm Booking",
  "member_member_account_club_billing": "Member account / club billing",
  "member_fitness_class": "Fitness class",
  "member_hotel_stay": "Hotel stay",
  "member_venue_service": "Venue / service",
  "member_you_may_cancel_this_dining_reservation_through_member_portal_cancellation": "You may cancel this Dining reservation through member portal cancellation.",
  "member_close_all_club_news": "Close all club news",
  "member_close_entry_notification": "Close entry notification",
  "member_close_club_news": "Close club news",
  "member_close_all_upcoming_bookings": "Close all upcoming bookings",
  "member_past_experiences": "past experiences",
  "member_live_experiences": "live experiences",
  "member_no_events_match_your_search_right_now": "No events match your search right now.",
  "member_no_past_events_just_yet": "No past events just yet.",
  "member_no_upcoming_events_right_now_please_check_back_soon": "No upcoming events right now. Please check back soon.",
  "member_signature_event": "Signature event",
  "member_an_exceptional_club_gathering": "An exceptional club gathering.",
  "member_club_venue": "Club venue",
  "member_guest_details": "Guest details",
  "member_confirm_attendance": "Confirm Attendance",
  "member_open_match_enabled": "Open match enabled",
  "member_none_selected": "None selected",
  "member_book_court": "Book court",
  "member_pending_join_requests": "Pending join requests",
  "member_select_a_court": "Select a court",
  "member_selected_day": "Selected day",
  "member_request_guest_pass": "Request Guest Pass",
  "member_all_caught_up": "All caught up",
  "member_unable_to_load_activities": "Unable to load activities.",
  "member__count_upcoming_session": "{count} upcoming session",
  "member__count_upcoming_sessions": "{count} upcoming sessions",
  "member_time_to_be_announced": "Time to be announced",
  "member_unable_to_update_booking": "Unable to update booking.",
  "member_join_waitlist": "Join waitlist",
  "member_join": "Join",
  "member__count_booked": "{count} booked",
  "member_unable_to_clear_notifications": "Unable to clear notifications",
  "member__count_new": "{count} new",
  "member_unable_to_load_reciprocal_clubs": "Unable to load reciprocal clubs.",
  "member_please_select_a_visit_date_to_request_a_guest_pass": "Please select a visit date to request a guest pass.",
  "member_unable_to_submit_request": "Unable to submit request.",
  "member_we_could_not_load_accommodations_right_now_please_try_again_shortly": "We could not load accommodations right now. Please try again shortly.",
  "member_please_choose_a_check_in_and_check_out_date": "Please choose a check-in and check-out date.",
  "member_check_out_must_be_after_check_in": "Check-out must be after check-in.",
  "member_please_add_at_least_one_guest": "Please add at least one guest.",
  "member_please_choose_valid_dates_before_requesting_a_booking": "Please choose valid dates before requesting a booking.",
  "member_we_were_unable_to_submit_your_request_please_try_again": "We were unable to submit your request. Please try again.",
  "member_unable_to_load_event_details": "Unable to load event details",
  "member_each_guest_needs_a_first_and_last_name": "Each guest needs a first and last name.",
  "member_registration_failed": "Registration failed",
  "member_location_coming_soon": "Location coming soon",
  "member_availability_on_request": "Availability on request",
  "member_select_your_stay_dates": "Select your stay dates",
  "member_date_to_be_announced": "Date to be announced",
  "member_you_re_in": "You’re in",
  "member__count_of_capacity_places_remaining": "{count} of {capacity} places remaining",
  "member_guests_allowed_up_to_count": "Guests allowed: up to {count}",
  "member_guests_allowed": "Guests allowed",
  "member_guests_not_permitted": "Guests not permitted",
  "member_more_details_will_be_announced_shortly": "More details will be announced shortly.",
  "member_host_member": "Host · Member",
  "member_live_price": "Live price",
  "member_add_name": "Add {name}",
  "member_member_on_file": "Member on file",
  "member_search_member_or_enter_guest_name": "Search member or enter guest name",
  "member_search_and_select_a_member": "Search and select a member",
  "member_host": "Host",
  "member_tap_to_book": "Tap to book",
  "member_join_now": "Join now",
  "member_request_spot": "Request spot",
  "member_balance_loading": "Balance loading",
  "member_explore_events": "Explore Events",
  "member_racquet_open_match": "Racquet · Open Match",
  "member_club_reservation": "Club reservation",
  "member_this_booking_was_paid_online_please_contact_the_club_directly_if_you_wish_to_cancel_or_discuss_a_refund": "This booking was paid online. Please contact the club directly if you wish to cancel or discuss a refund.",
  "member_the_online_cancellation_period_has_passed_please_contact_the_club": "The online cancellation period has passed. Please contact the club.",
  "member_online_cancellation_is_not_available_for_this_booking_please_contact_the_club": "Online cancellation is not available for this booking. Please contact the club.",
  "member_unable_to_cancel_booking": "Unable to cancel booking.",
  "member_your_tee_time_has_been_cancelled": "Your tee time has been cancelled.",
  "member_this_booking_is_inside_the_cancellation_notice_period_please_contact_the_club_to_cancel_this_booking": "This booking is inside the cancellation notice period. Please contact the club to cancel this booking.",
  "member_please_contact_the_club_to_cancel_this_booking": "Please contact the club to cancel this booking.",
  "member_refund_outcome_no_refund": "Refund outcome: no refund",
  "member_cancellation_requires_manual_review": "Cancellation requires manual review.",
  "member_unable_to_cancel_booking_please_contact_the_club": "Unable to cancel booking. Please contact the club.",
  "member_your_racquet_booking_has_been_cancelled": "Your racquet booking has been cancelled.",
  "member_your_spa_booking_has_been_cancelled": "Your spa booking has been cancelled.",
  "member_your_fitness_booking_has_been_cancelled": "Your fitness booking has been cancelled.",
  "member_this_stay_is_inside_the_cancellation_notice_period_please_contact_the_club_to_cancel_this_booking": "This stay is inside the cancellation notice period. Please contact the club to cancel this booking.",
  "member_your_hotel_booking_has_been_cancelled": "Your hotel booking has been cancelled.",
  "member_cancellation_not_available_via_the_mobile_app": "Cancellation not available via the mobile app.",
  "member_the_online_cancellation_window_has_closed_please_contact_the_club": "The online cancellation window has closed. Please contact the club.",
  "member_this_reservation_can_no_longer_be_cancelled": "This reservation can no longer be cancelled.",
  "member_this_reservation_could_not_be_found_please_contact_the_club": "This reservation could not be found. Please contact the club.",
  "member_cancellation_is_not_currently_available_please_contact_the_club": "Cancellation is not currently available. Please contact the club.",
  "member_your_tee_time_is_confirmed": "Your tee time is confirmed",
  "member_your_table_is_reserved": "Your table is reserved",
  "member_your_stay_is_confirmed": "Your stay is confirmed",
  "member_your_open_match_is_live": "Your open match is live",
  "member_your_booking_is_confirmed": "Your booking is confirmed",
  "member_open_match_created": "Open match created",
  "member_your_match_is_now_visible_to_eligible_club_members_who_can_join_or_request_a_place_using_your_chosen_join_policy": "Your match is now visible to eligible club members, who can join or request a place using your chosen join policy.",
  "member_loading_booking_details": "Loading booking details",
  "member_club_experience": "Club experience",
  "member_players_count_of_capacity": "Players · {count} of {capacity}",
  "member__count_places_open_type_policy": "{count} places open · {type} · {policy}",
  "member__adults_adults_children_children_rooms_rooms": "{adults} adults, {children} children · {rooms} rooms",
  "member_stay_guests": "Stay guests",
  "member_unable_to_load_course_details_right_now": "Unable to load course details right now.",
  "member_unable_to_load_this_tee_time_please_return_to_tee_times_and_try_again": "Unable to load this tee time. Please return to tee times and try again.",
  "member_at_least_one_player_is_required": "At least one player is required.",
  "member_please_select_holes_9_or_18": "Please select holes (9 or 18).",
  "member_select_how_many_players_you_want_to_join_your_open_group": "Select how many players you want to join your open group.",
  "member_open_group_spots_would_exceed_the_maximum_of_4_players": "Open group spots would exceed the maximum of 4 players.",
  "member_this_tee_time_is_no_longer_available_please_reselect_a_tee_time": "This tee time is no longer available, please reselect a tee time.",
  "member_we_can_t_price_this_tee_time_right_now_please_try_another_time_or_contact_the_club": "We can't price this tee time right now. Please try another time or contact the club.",
  "member_we_couldn_t_calculate_your_booking_price_try_again_in_a_moment": "We couldn't calculate your booking price. Try again in a moment.",
  "member_unable_to_join_this_open_group_right_now": "Unable to join this open group right now.",
  "member_we_could_not_complete_the_booking_please_check_your_details_and_try_again": "We could not complete the booking. Please check your details and try again.",
  "member_court_details_not_loaded": "Court details not loaded",
  "member_start_time_missing": "Start time missing",
  "member_please_resolve_player_details": "Please resolve player details",
  "member_unable_to_load_court_details_right_now": "Unable to load court details right now.",
  "member_please_select_a_valid_duration_for_this_court_and_time": "Please select a valid duration for this court and time.",
  "member_invalid_sport_type": "Invalid sport type",
  "member_unable_to_join_open_match_right_now": "Unable to join open match right now.",
  "member_spot_joined_payment_required_to_finalize_your_spot": "Spot joined. Payment required to finalize your spot.",
  "member_request_sent_you_will_be_notified_if_approved": "Request sent. You will be notified if approved.",
  "member_unable_to_complete_payment_right_now": "Unable to complete payment right now.",
  "member_charged_to_account": "Charged to account",
  "member_unable_to_load_open_match_details_right_now": "Unable to load open match details right now.",
  "member_unable_to_update_join_request": "Unable to update join request.",
  "member_request_approved": "Request approved.",
  "member_request_rejected": "Request rejected.",
  "member_unable_to_load_this_course_right_now": "Unable to load this course right now.",
  "member_unable_to_load_tee_times_right_now": "Unable to load tee times right now.",
  "member_course_not_found_or_inactive": "Course not found or inactive.",
  "member_you_already_joined_this_open_group": "You already joined this open group.",
  "member_this_open_group_is_full": "This open group is full.",
  "member_this_booking_is_no_longer_open_for_joins": "This booking is no longer open for joins.",
  "member_this_booking_is_no_longer_available": "This booking is no longer available.",
  "member_we_could_not_find_your_member_profile_for_this_club": "We could not find your member profile for this club.",
  "member_you_are_not_eligible_to_join_this_open_group": "You are not eligible to join this open group.",
  "member_member_name_required": "Member name required",
  "member_guests_are_not_allowed_for_this_course_please_select_a_member": "Guests are not allowed for this course. Please select a member.",
  "member_select_a_member_from_the_list": "Select a member from the list",
  "member_guest_full_name_email_and_phone_are_required": "Guest full name, email, and phone are required",
  "member_we_could_not_complete_the_booking_please_try_again": "We could not complete the booking. Please try again.",
  "member_primary_member_required": "Primary member required",
  "member_guests_are_not_allowed_on_this_court": "Guests are not allowed on this court",
  "member_guest_email_and_phone_are_required": "Guest email and phone are required",
  "member_available_tee_times": "Available tee times",
  "member_select_a_course": "Select a course",
  "member_back_to_courses": "Back to courses",
  "member_choose_your_service": "Choose your service",
  "member_book_a_class": "Book a class",
  "member_that_court_has_just_been_taken_choose_another_available_time": "That court has just been taken. Choose another available time.",
  "member_payment_could_not_be_completed_your_court_has_not_been_booked": "Payment could not be completed. Your court has not been booked.",
  "member_we_couldn_t_complete_your_booking_your_court_has_not_been_booked_or_charged": "We couldn’t complete your booking. Your court has not been booked or charged.",
  "member_we_couldn_t_complete_your_booking_please_try_again": "We couldn’t complete your booking. Please try again.",
  "member_unable_to_load_course_rates_right_now": "Unable to load course rates right now.",
  "member_unable_to_load_courses_right_now": "Unable to load courses right now.",
  "member_home": "Home",
  "member_dining": "Dining",
  "member_profile": "Profile",
  "member_member": "Member",
  "member_dashboard": "Dashboard",
  "member_club": "Club",
  "member_select_date": "Select date",
  "member__count_holes": "{count} holes",
  "member_player_caption": "Player",
  "member_players_caption": "Players",
  "member_guests": "guests",
  "member_joined": "Joined",
  "member_friendly": "Friendly",
  "member_notification": "Notification",
  "member_please_try_again": "Please try again.",
  "member_notifications": "Notifications",
  "member_loading": "Loading…",
  "member_refresh": "Refresh",
  "member_clear_all": "Clear All",
  "member_activities": "Activities",
  "member_academy": "Academy",
  "member_reciprocal_clubs": "Reciprocal Clubs",
  "member_accommodations": "Accommodations",
  "member_voting": "Voting",
  "member_review": "Review",
  "member_dates": "Dates",
  "member_occupancy": "Occupancy",
  "member_room": "Room",
  "member_room_type": "Room Type",
  "member_select_dates": "Select dates",
  "member_total": "Total",
  "member_from": "From",
  "member_view_details": "View details",
  "member_check_in": "Check-in",
  "member_check_out": "Check-out",
  "member_rooms_caption": "Rooms",
  "member_close": "Close",
  "member_room_details": "Room details",
  "member_cancel": "Cancel",
  "member_no_upcoming_sessions": "No upcoming sessions",
  "member_activity": "Activity",
  "member_full": "Full",
  "member_unable_to_load_activity": "Unable to load activity.",
  "member_waitlisted": "Waitlisted",
  "member_available": "available",
  "member_capacity_count": "Capacity: {count}",
  "member_current_balance": "Current Balance",
  "member_contact_front_desk": "Contact Front Desk",
  "member_golf_booking_caption": "Golf Booking",
  "member_reservation": "Reservation",
  "member_open": "open",
  "member_pdf_announcement": "PDF announcement",
  "member_tee_time": "Tee Time",
  "member_this_booking_has_already_been_cancelled": "This booking has already been cancelled.",
  "member_golf_course": "Golf course",
  "member_booked": "booked",
  "member_date": "Date",
  "member_holes_caption": "Holes",
  "member_add_ons": "Add-ons",
  "member_qty": "Qty",
  "member_deadline": "Deadline:",
  "member_racquet_booking_caption": "Racquet Booking",
  "member_spa_booking": "Spa Booking",
  "member_spa": "Spa",
  "member_service": "Service",
  "member_spa_service": "Spa service",
  "member_fitness_class_caption": "Fitness Class",
  "member_fitness": "Fitness",
  "member_hotel_rooms": "Hotel / Rooms",
  "member_accommodation": "Accommodation",
  "member_dining_area": "Dining area",
  "member_party_size": "Party size",
  "member_cost": "Cost",
  "member_status": "Status",
  "member_good_morning": "Good Morning",
  "member_view_all": "View All",
  "member_club_news": "Club News",
  "member_retry": "Retry",
  "member_member_portal_entry_notification": "Member Portal Entry Notification",
  "member_of": "of",
  "member_loading_reservation_details": "Loading reservation details…",
  "member_complimentary": "Complimentary",
  "member_unable_to_load_events": "Unable to load events",
  "member_upcoming_caption": "Upcoming",
  "member_past_events": "Past Events",
  "member_event": "Event",
  "member_reserved": "Reserved",
  "member_reserve": "Reserve",
  "member_add_guest": "Add Guest",
  "member_first_name": "First name",
  "member_last_name": "Last name",
  "member_email": "Email",
  "member_phone": "Phone",
  "member_dietary": "Dietary",
  "member_notes": "Notes",
  "member_guest": "Guest",
  "member_try_again": "Try again",
  "member_member_price": "Member price",
  "member_continue": "Continue",
  "member_classes": "Classes",
  "member_coach": "Coach",
  "member_golf": "Golf",
  "member_loading_tee_times": "Loading tee times…",
  "member_golf_tee_times": "Golf tee times",
  "member_select": "Select",
  "member_unable_to_load": "Unable to load",
  "member_back": "Back",
  "member_min": "min",
  "member_booking_type": "Booking type",
  "member_add_player": "Add player",
  "member_guest_name": "Guest name",
  "member_no_booking_durations_are_configured_for_this_court": "No booking durations are configured for this court.",
  "member_racquet": "Racquet",
  "member_duration": "Duration",
  "member_select_duration": "Select duration",
  "member_select_booking_type": "Select booking type",
  "member_remove": "Remove",
  "member_name": "Name",
  "member_guest_phone": "Guest phone",
  "member_confirmed": "confirmed",
  "member_pending_requests": "Pending requests",
  "member_none": "None",
  "member_reject": "Reject",
  "member_approve": "Approve",
  "member_loading_courts": "Loading courts…",
  "member_show_less": "Show less",
  "member_availability": "Availability",
  "member_unavailable": "Unavailable",
  "member_awaiting_approval": "Awaiting approval",
  "member_checkout": "Checkout",
  "member_grid": "Grid",
  "member_list": "List",
  "member_reciprocal_club_caption": "Reciprocal club",
  "member_more": "more",
  "member__count_left": "{count} left",
  "member_limited_availability": "Limited availability",
  "member_creating_match": "Creating match…",
  "member_reserving_court": "Reserving court…",
  "member_manage_activities": "Manage Activities",
  "member_you_are_not_assigned_to_any_activities": "You are not assigned to any activities.",
  "member_managed_activity": "Managed activity",
  "member_manage_sessions": "Manage sessions",
  "member_unable_to_load_sessions": "Unable to load sessions.",
  "member_unable_to_update_session": "Unable to update session.",
  "member_you_do_not_have_access_to_this_activity": "You do not have access to this activity.",
  "member_viewing_roster": "Viewing roster",
  "member_plan_your_next_experience_with_precision_and_ease": "Plan your next experience with precision and ease.",
  "member_add_a_concierge_note": "Add a concierge note",
  "member_decrease_adults_for_room_room": "Decrease adults for room {room}",
  "member_increase_adults_for_room_room": "Increase adults for room {room}",
  "member_decrease_children_for_room_room": "Decrease children for room {room}",
  "member_increase_children_for_room_room": "Increase children for room {room}",
  "member__holes_hole_pricing": "{holes}-hole pricing",
  "member_pay_amount": "Pay {amount}",
  "member_guest_count": "Guest #{count}",
  "member_member_count": "Member #{count}",
  "member_calculating": "Calculating…",
  "member_choose_duration_for_name": "Choose duration for {name}",
  "member_book_sport": "Book {sport}",
  "member_see_all_count": "See all {count}",
  "member_view_roster": "View roster",
  "member_unable_to_load_roster": "Unable to load roster.",
  "member_unable_to_create_session": "Unable to create session.",
  "member_sessions_caption": "Sessions",
  "member_add_session": "Add session",
  "member_no_sessions_yet": "No sessions yet.",
  "member_cancelled": "Cancelled",
  "member_active": "Active",
  "member_capacity": "Capacity",
  "member_roster": "Roster",
  "member_clear": "Clear",
  "member_loading_roster": "Loading roster…",
  "member_no_bookings_yet": "No bookings yet.",
  "member_member_caption": "Member",
  "member_select_a_session_to_view_the_roster": "Select a session to view the roster.",
  "member_start_time": "Start time",
  "member_select_time": "Select time",
  "member_end_time": "End time",
  "member_optional": "Optional",
  "member_processing_payment": "Processing payment…",
  "member_remove_name": "Remove {name}",
  "member_pending": "Pending",
  "member_paid": "Paid",
  "member_completed": "Completed",
  "member_no_show": "No-show",
  "member_refunded": "Refunded",
  "member_failed": "Failed",
  "member_expired": "Expired",
  "member_held": "Held",
  "member_status_unavailable": "Status unavailable",
  "member_booking": "Booking…",
  "member_requesting": "Requesting…",
  "member_joining": "Joining…",
  "member_guest_full_name": "Guest full name",
  "member_book_tee_time": "Book tee time",
  "member_booking_image_unavailable": "Booking image unavailable",
  "member_expected_refund_amount": "Expected refund: {amount}",
  "member_expected_refund_amount_cancellation_fee_fee": "Expected refund: {amount}; cancellation fee {fee}",
  "member__minutes_minutes_price": "{minutes} minutes{price}",
  "member_open_type_match_at_time_on_court_count_places_left": "Open {type} match at {time} on {court}, {count} places left",
  "member_reciprocal_access": "Reciprocal Access",
  "member_booking_cancelled": "Booking cancelled",
  "member_visit_request_approved": "Visit request approved",
  "member_scheduled_class": "Scheduled class",
  "member_places_available_count": "Places available: {count}",
  "member_primary_member": "Primary member",
  "member_hotel_reservation": "Hotel Reservation",
  "member__sport_open_match": "{sport} · Open Match",
  "member_facility_unavailable": "Facility unavailable",
  "member_book_tee_times": "Book tee times",
  "member_reserve_courts": "Reserve courts",
  "member_book_spa_services": "Book spa services",
  "member_book_fitness_classes": "Book fitness classes",
  "member_booking_coming_soon": "Booking coming soon",
  "member_opening_secure_checkout": "Opening secure checkout",
  "member_please_wait_while_we_prepare_your_payment": "Please wait while we prepare your payment.",
  "member_connecting_to_secure_checkout": "Connecting to secure checkout…",
  "member_your_member_portal_tab_will_stay_open": "Your member portal tab will stay open.",
  "member_payment_received": "Payment received",
  "member_thank_you_your_payment_is_processing": "Thank you — your payment is processing.",
  "member_your_secure_checkout_has_completed_we_ll_update_your_account_as_soon_as_the_club_s_payment_confirmation_is_received": "Your secure checkout has completed. We’ll update your account as soon as the club’s payment confirmation is received.",
  "member_no_payment_was_taken": "No payment was taken.",
  "member_you_can_return_to_your_account_and_start_secure_checkout_again_whenever_you_are_ready": "You can return to your account and start secure checkout again whenever you are ready.",
  "member_payment_declined": "Payment declined",
  "member_your_payment_could_not_be_completed": "Your payment could not be completed.",
  "member_checkout_normally_shows_card_decline_messages_before_redirecting_this_page_is_here_if_the_club_sends_you_a_manual_declined_payment_link": "Checkout normally shows card-decline messages before redirecting. This page is here if the club sends you a manual declined-payment link.",
  "member_secure_checkout_completed_in_stripe": "Secure checkout completed in Stripe.",
  "member_return_to_account": "Return to account",
  "member_returning_you_to_your_booking": "Returning you to your booking…",
  "member_your_booking_is_confirmed_you_can_close_this_checkout_tab_and_continue_in_your_original_booking_tab": "Your booking is confirmed. You can close this checkout tab and continue in your original booking tab.",
  "member_return_to_booking_confirmation": "Return to booking confirmation",
  "member_we_could_not_confirm_your_booking": "We could not confirm your booking",
  "member_payment_was_received_but_we_could_not_confirm_the_booking_automatically_please_contact_the_club": "Payment was received, but we could not confirm the booking automatically. Please contact the club.",
  "member_payment_was_received_but_the_booking_could_not_be_finalised_automatically_please_contact_the_club": "Payment was received, but the booking could not be finalised automatically. Please contact the club.",
  "member_still_confirming_your_payment_this_may_take_a_few_moments": "Still confirming your payment. This may take a few moments.",
  "member_confirming_your_payment": "Confirming your payment…",
  "member_loading_secure_payment_link": "Loading secure payment link…",
  "member_payment_link_unavailable": "Payment link unavailable",
  "member_this_guest_payment_token_is_invalid_or_expired": "This guest payment token is invalid or expired.",
  "member_privana_guest_payment": "Privana guest payment",
  "member_event_guest_ticket": "Event guest ticket",
  "member_date_time_tbc": "Date/time TBC",
  "member_paid_online_thank_you": "Paid online. Thank you.",
  "member_pay_securely_with_privana_pay": "Pay securely with Privana Pay",
  "member_your_payment_succeeded_we_are_finalising_your_booking_now": "Your payment succeeded. We are finalising your booking now."
}
